import { StyleNavItem } from './style'
import Button from '@components/button'
import { useLocation, useNavigate } from 'react-router-dom'

const NavItems = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const items = [
    { label: 'Company', navigateTo: '/' },
    { label: 'Service', navigateTo: '/service' },
    { label: 'About Us', navigateTo: '/about-us' },
    {
      label: 'Blogs',
      navigateTo: 'https://blogs.supchar.com',
      external: true,
    },
    { label: 'Contact us', navigateTo: '/contact-us' },
  ]

  return (
    <StyleNavItem>
      {items.map((navitem, i) => {
        const isActive = location.pathname === navitem.navigateTo

        const handleClick = () => {
          if (navitem.external) {
            window.open(navitem.navigateTo, '_blank')
          } else {
            navigate(navitem.navigateTo)
          }
        }

        return (
          <Button
            key={i}
            title={navitem.label}
            styleButton={`padding: 0px 10px; background: transparent; border-radius: 0; ${
              isActive ? 'border-bottom: 2px solid #1d286a' : ''
            }`}
            height={40}
            tc={isActive ? 'primary' : 'text'}
            bg={'white'}
            onClick={handleClick}
          />
        )
      })}
    </StyleNavItem>
  )
}

export default NavItems
